// While a request for `key` is running, callers get the same promise instead of starting another one.
// The entry is removed when it settles, so a later call (e.g. a retry after an error) sends a new request.
export function shareInFlight(inFlight, key, start) {
  if (inFlight.has(key)) return inFlight.get(key);
  const request = start().finally(() => inFlight.delete(key));
  inFlight.set(key, request);
  return request;
}
